import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleActivitiesQuantityPerStudentUseCaseInterface } from 'domain/usecases';

export class RemoteHandleActivitiesQuantityPerStudent
  implements HandleActivitiesQuantityPerStudentUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleActivitiesQuantityPerStudentUseCaseInterface.Result>,
  ) {}

  async execute(
    params: HandleActivitiesQuantityPerStudentUseCaseInterface.Params,
  ): Promise<HandleActivitiesQuantityPerStudentUseCaseInterface.Result> {
    const {
      type: reportType,
      model: type,
      situation: status,
      ...restParams
    } = params;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}/${reportType}`, {
        ...restParams,
        type,
        status,
      }),
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
